import { render, staticRenderFns } from "./Component-StartTaskList.vue?vue&type=template&id=534a9d2b&"
import script from "./Component-StartTaskList.vue?vue&type=script&lang=js&"
export * from "./Component-StartTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports